import {Component, OnDestroy, OnInit} from '@angular/core';
import {ProjectConstants} from '../../../project-constants';
import * as toastr from 'toastr';
import {FormBuilder, FormGroup, NgForm, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {ShareNameDeviceModel} from '../../../../models/ShareNameDeviceModel';
import {SharenameDeviceAnagrafService} from '../../../general-services/service-sharename-device-anagraf/sharename-device-anagraf.service';

@Component({
  selector: 'app-new-sharename-device-anagraf',
  templateUrl: './new-sharename-device-anagraf.component.html',
  styleUrls: ['./new-sharename-device-anagraf.component.scss']
})
export class NewSharenameDeviceAnagrafComponent extends ProjectConstants implements OnInit, OnDestroy {
  shareName: ShareNameDeviceModel;
  formValidator: FormGroup;
  formBuilder: FormBuilder;
  saveSubscribe: Subscription;

  constructor(private route: ActivatedRoute, private router: Router,
              private shareNameService: SharenameDeviceAnagrafService) {
    super();

    this.shareName = new ShareNameDeviceModel();

    this.formBuilder = new FormBuilder();

    this.formValidator = this.formBuilder.group({
      cod: [this.shareName.cod, [Validators.required]],
      description: [this.shareName.description, [Validators.required]]
    });
  }

  ngOnInit() {

  }

  cancel(event: any) {
    event.preventDefault();
   // this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.SHARENAME_DEVICE_ANAGRF]);
  }

  save(event: any, form: NgForm, clickSalva ?: boolean) {
    if (event.key === 'Enter' || clickSalva) {
      event.preventDefault();
      this.shareName.cod = this.formValidator.value.cod;
      this.shareName.description = this.formValidator.value.description;
      this.saveSubscribe = this.shareNameService.save(this.shareNameService.baseUrl, this.shareName).subscribe(
        (result: any) => {
          if (result === -1) {
            toastr.options.timeout = 5000;
            toastr.warning('Duplicate item, ShareName Device Cod already exists', 'Warning');
          } else {
       //     this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.SHARENAME_DEVICE_ANAGRF]);
          }
        });
    }
  }

  ngOnDestroy(): void {
    if (this.saveSubscribe) {
      this.saveSubscribe.unsubscribe();
    }
  }
}
